/**
 * Creates a deep copy of an object and removes any properties with a value of `null` or `undefined`.
 * This is useful for removing undefined properties from an object before returning it from getServerSideProps.
 *
 * @param obj - The object to nullify.
 * @returns A new object with `null` and `undefined` properties removed.
 * @template T - The type of the object.
 */
//

export const nullify = <T>(obj: Record<string, unknown>): T =>
  JSON.parse(JSON.stringify(obj)) as T;
